(() => {
  const shakeTimers = new Map();

  function initBundle(wrapper) {
    if (wrapper.dataset.bbInit) return;
    const form = wrapper.closest('form');
    const configEl = wrapper.querySelector('[data-bundle-config]');
    if (!form || !configEl) return;
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    const fallback = form.querySelector('[data-bundle-fallback]');
    const addBtn = form.querySelector('[data-add-button]');
    const buyBtn = form.querySelector('[data-buy-now]');
    const itemsInput = form.querySelector('[data-bundle-items]');
    const message = form.querySelector('[data-bundle-message]');

    const rowsContainer = wrapper.querySelector('[data-bundle-rows]');
    const tierButtons = [...wrapper.querySelectorAll('[data-bundle-tier]')];
    const moreToggle = wrapper.querySelector('[data-bundle-more-toggle]');
    const morePanel = wrapper.querySelector('[data-bundle-more-controls]');
    const addFrameBtn = wrapper.querySelector('[data-bundle-add-frame]');
    const removeFrameBtn = wrapper.querySelector('[data-bundle-remove-frame]');
    const frameTotalEl = wrapper.querySelector('[data-bundle-frame-total]');
    const morePriceEl = wrapper.querySelector('[data-bundle-more-price]');
    const colorsSection = wrapper.querySelector('[data-bundle-colors]');
    const swatchesContainer = wrapper.querySelector('[data-bundle-swatches]');
    const stockMessageEl = wrapper.querySelector('[data-bundle-stock-message]');
    const giftProgressEl = wrapper.querySelector('[data-bundle-gift-progress]');
    const priceSummary = wrapper.querySelector('[data-bundle-price-summary]');
    const totalPriceEl = wrapper.querySelector('[data-bundle-total-price]');
    const totalRegularEl = wrapper.querySelector('[data-bundle-total-regular]');
    const totalSavingsEl = wrapper.querySelector('[data-bundle-total-savings]');

    if (!swatchesContainer) return;

    wrapper.dataset.bbInit = 'true';
    if (fallback) fallback.hidden = true;
    wrapper.hidden = false;
    requestAnimationFrame(() => wrapper.classList.add('is-ready'));
    if (addBtn && !addBtn.dataset.original) addBtn.dataset.original = addBtn.textContent;
    if (buyBtn && !buyBtn.dataset.original) buyBtn.dataset.original = buyBtn.textContent;

    let n = 0;
    let selectedColor = null;
    let stockBlocked = false;
    let wasReady = false;
    let shakeInterval = null;

    function pulse(el, className, duration) {
      if (!el) return;
      el.classList.remove(className);
      void el.offsetWidth;
      el.classList.add(className);
      setTimeout(() => el.classList.remove(className), duration);
    }

    function stopShaking() {
      if (shakeInterval) clearInterval(shakeInterval);
      shakeInterval = null;
      shakeTimers.delete(wrapper);
    }

    const tierFor = count => config.tiers.find(t => t.n === count);
    const colorFor = label => config.colors.find(c => c.label === label);

    function colorCanFulfill(label, count) {
      const c = colorFor(label);
      if (!c) return false;
      if (!c.variantAvailable) return false;
      if (!c.tracked) return true;
      return c.qty >= count;
    }

    function renderTierCards() {
      [1, 2, 3].forEach(t => {
        const btn = wrapper.querySelector('[data-bundle-tier="' + t + '"]');
        const data = tierFor(t);
        if (!btn || !data) return;
        const priceEl = btn.querySelector('[data-tier-price]');
        const regularEl = btn.querySelector('[data-tier-regular]');
        const savingsEl = btn.querySelector('[data-tier-savings]');
        if (priceEl) priceEl.textContent = data.price;
        if (regularEl) {
          regularEl.textContent = data.regular;
          regularEl.hidden = !data.hasSavings;
        }
        if (savingsEl) {
          savingsEl.textContent = data.hasSavings ? 'Save ' + data.savings : '';
          savingsEl.hidden = !data.hasSavings;
        }
        if (!data.available) btn.disabled = true;
      });
    }

    function updateSwatchStates() {
      swatchesContainer.querySelectorAll('[data-swatch-value]').forEach(swatch => {
        swatch.setAttribute('aria-checked', swatch.dataset.swatchValue === selectedColor ? 'true' : 'false');
      });
    }

    const isComplete = () => n > 0 && Boolean(selectedColor) && !stockBlocked;

    function buildLineItems() {
      if (!isComplete()) return [];
      const variantGid = config.variants[selectedColor];
      const variantId = Number(String(variantGid).split('/').pop());
      return Array.from({ length: n }, () => ({ id: variantId, quantity: 1 }));
    }

    function updatePriceSummary() {
      if (!priceSummary) return;
      const data = tierFor(n);
      if (!data || n <= 3) {
        priceSummary.hidden = true;
      } else {
        if (totalPriceEl) totalPriceEl.textContent = data.price;
        if (totalRegularEl) {
          totalRegularEl.textContent = data.regular;
          totalRegularEl.hidden = !data.hasSavings;
        }
        if (totalSavingsEl) {
          totalSavingsEl.textContent = data.hasSavings ? 'You save ' + data.savings : '';
          totalSavingsEl.hidden = !data.hasSavings;
        }
        priceSummary.hidden = false;
      }
      if (morePriceEl) {
        morePriceEl.textContent = data ? data.price : '';
      }
    }

    function updateGiftProgress() {
      if (!giftProgressEl || !config.showGift) return;
      const threshold = config.giftThreshold || 3;
      if (n > 0 && n < threshold) {
        const needed = threshold - n;
        let text = (config.giftProgressTemplate || '').replace('{n}', String(needed));
        if (needed !== 1) text = text.replace(/\bframe\b/, 'frames');
        giftProgressEl.textContent = text;
        giftProgressEl.hidden = false;
      } else {
        giftProgressEl.hidden = true;
      }
    }

    function updateStockMessage() {
      if (!stockMessageEl) return;
      if (stockBlocked && selectedColor) {
        const c = colorFor(selectedColor);
        const left = c ? Math.max(0, c.qty) : 0;
        stockMessageEl.textContent = 'Only ' + left + ' ' + selectedColor + ' frame' + (left === 1 ? '' : 's') + ' left in stock — choose fewer frames or a different color.';
        stockMessageEl.hidden = false;
      } else {
        stockMessageEl.hidden = true;
      }
    }

    function updateCta() {
      const data = tierFor(n);
      const complete = isComplete();
      const ready = complete && data && data.available;
      if (addBtn) {
        addBtn.disabled = !ready;
        addBtn.textContent = addBtn.dataset.original;
      }
      if (buyBtn) {
        buyBtn.disabled = !ready;
        buyBtn.textContent = buyBtn.dataset.original;
      }
      if (message) {
        if (n === 0) message.textContent = '';
        else if (stockBlocked) message.textContent = '';
        else if (!complete) message.textContent = config.incompleteMessage;
        else message.textContent = '';
      }
      if (ready && !wasReady) {
        stopShaking();
        shakeInterval = setInterval(() => pulse(addBtn, 'is-shaking', 500), 6000);
        shakeTimers.set(wrapper, shakeInterval);
      } else if (!ready && wasReady) {
        stopShaking();
      }
      wasReady = ready;
    }

    function updateItemsInput() {
      if (!itemsInput) return;
      itemsInput.value = isComplete() ? JSON.stringify({ items: buildLineItems() }) : '';
    }

    function render() {
      if (colorsSection) colorsSection.hidden = n === 0;
      updateSwatchStates();
      updatePriceSummary();
      updateGiftProgress();
      updateStockMessage();
      updateCta();
      updateItemsInput();

      tierButtons.forEach(btn => {
        const active = Number(btn.dataset.bundleTier) === n;
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (moreToggle && morePanel) {
        const inMoreMode = n > 3;
        moreToggle.setAttribute('aria-expanded', inMoreMode ? 'true' : 'false');
        moreToggle.classList.toggle('is-active', inMoreMode);
        morePanel.hidden = !inMoreMode;
        if (frameTotalEl) frameTotalEl.textContent = inMoreMode ? n + ' frames' : '';
        if (removeFrameBtn) removeFrameBtn.disabled = n <= 1;
        if (addFrameBtn) addFrameBtn.disabled = n >= config.maxFrames;
      }
    }

    function revalidateColorForCount() {
      if (!selectedColor) {
        stockBlocked = false;
        return;
      }
      stockBlocked = !colorCanFulfill(selectedColor, n);
    }

    function setFrameCount(next) {
      next = Math.max(1, Math.min(config.maxFrames, next));
      n = next;
      revalidateColorForCount();
      render();
    }

    tierButtons.forEach(btn => {
      btn.addEventListener('click', () => setFrameCount(Number(btn.dataset.bundleTier)));
    });

    if (rowsContainer) {
      rowsContainer.addEventListener('keydown', event => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const focusable = tierButtons;
        const idx = focusable.indexOf(document.activeElement);
        if (idx === -1) return;
        event.preventDefault();
        const dir = (event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 1 : -1;
        const nextIdx = (idx + dir + focusable.length) % focusable.length;
        focusable[nextIdx].focus();
        setFrameCount(Number(focusable[nextIdx].dataset.bundleTier));
      });
    }

    if (moreToggle && morePanel) {
      moreToggle.addEventListener('click', () => {
        const expanding = moreToggle.getAttribute('aria-expanded') !== 'true';
        if (expanding) {
          setFrameCount(Math.max(4, n));
        } else if (n > 3) {
          setFrameCount(3);
        }
      });
    }

    if (addFrameBtn) {
      addFrameBtn.addEventListener('click', () => {
        if (n === 0) return;
        setFrameCount(n + 1);
        pulse(addFrameBtn, 'is-bouncing', 400);
      });
    }
    if (removeFrameBtn) {
      removeFrameBtn.addEventListener('click', () => {
        if (n <= 1) return;
        setFrameCount(n - 1);
        pulse(removeFrameBtn, 'is-bouncing', 400);
      });
    }

    swatchesContainer.addEventListener('click', event => {
      const swatch = event.target.closest('[data-swatch-value]');
      if (!swatch || swatch.disabled) return;
      const label = swatch.dataset.swatchValue;
      if (!colorCanFulfill(label, n)) {
        selectedColor = label;
        stockBlocked = true;
        render();
        pulse(stockMessageEl, 'is-bouncing', 400);
        return;
      }
      selectedColor = label;
      stockBlocked = false;
      render();
      pulse(swatch, 'is-bouncing', 400);
    });

    swatchesContainer.addEventListener('keydown', event => {
      if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const focusable = [...swatchesContainer.querySelectorAll('[data-swatch-value]:not(:disabled)')];
      const idx = focusable.indexOf(document.activeElement);
      if (idx === -1) return;
      event.preventDefault();
      const dir = (event.key === 'ArrowDown' || event.key === 'ArrowRight') ? 1 : -1;
      const nextIdx = (idx + dir + focusable.length) % focusable.length;
      focusable[nextIdx].focus();
      focusable[nextIdx].click();
    });

    form.addEventListener('bundle:submitted', () => {
      if (itemsInput) itemsInput.value = '';
      stopShaking();
      wasReady = false;
    });

    renderTierCards();
    if (config.defaultFrames > 0) {
      setFrameCount(config.defaultFrames);
    } else {
      render();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-builder]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bundle-builder]').forEach(wrapper => {
      const shakeInterval = shakeTimers.get(wrapper);
      if (shakeInterval) clearInterval(shakeInterval);
      shakeTimers.delete(wrapper);
    });
  });
})();
